module.exports = __webpack_public_path__ + "static/media/step2.6d5f5ff4.svg";